var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingXPBuffFactor } from "../../../balancingSelectors/selectBalancingBuffs";
import { IdStyles } from "../../../less/IdStyles";
import { selectCoopInfo } from "../../../selectors/selectCoopInfo";
import { selectCoopProjectInfo } from "../../../selectors/selectCoopProjectInfo";
import { selectRunningCoopProjectEventInfo } from "../../../selectors/selectEventInfo";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../utils/sound/utilSound";
import { Badge } from "../../generic/badge/Badge";
import { IdBadgePosition } from "../../generic/badge/IdBadgePosition";
import { GridItemContainerDefault } from "../../generic/common/GridItemContainerDefault";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../../generic/number-format/TypeNumberFormat";
var GridItemCoopProjectDOM = /** @class */ (function (_super) {
    __extends(GridItemCoopProjectDOM, _super);
    function GridItemCoopProjectDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTimerBadge = function () {
            var _a = _this.props, item = _a.item, activeProject = _a.activeProject;
            var badge;
            if (activeProject && activeProject.projectId && item.id === activeProject.typeId) {
                badge = (React.createElement(Badge, { position: IdBadgePosition.TopRight },
                    React.createElement(Icon, { icon: IdIcon.TimeIcn, styleId: "coop-project-badge-icon " + IdStyles.IconMedium })));
            }
            return badge;
        };
        _this.getEventBadge = function () {
            var _a = _this.props, item = _a.item, runningCoopProjectEvent = _a.runningCoopProjectEvent;
            var badge;
            if (runningCoopProjectEvent) {
                var proto = runningCoopProjectEvent.proto;
                if (item.id === proto.rewardId) {
                    var buffFactor = selectBalancingXPBuffFactor(item.buffId);
                    badge = (React.createElement(Badge, { position: IdBadgePosition.TopLeft },
                        React.createElement(Icon, { icon: IdIcon.CoopXpBoostIcn, styleId: "flex flex--guts coop-project-badge-icon " + IdStyles.IconMedium },
                            React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: buffFactor, format: TypeNumberFormat.Multiplication }))));
                }
            }
            return badge;
        };
        return _this;
    }
    GridItemCoopProjectDOM.prototype.render = function () {
        var _a = this.props, item = _a.item, onClick = _a.onClick, className = _a.className, coopLevel = _a.coopLevel;
        var projectBackground = "background_" + item.id;
        var projectBackgroundClass = "coop-project-" + projectBackground;
        var isLocked = item.requCoopLevel > coopLevel;
        var onClickWithSound;
        if (!isLocked) {
            onClickWithSound = function () {
                utilSound.event(IdEventSoundCore.ButtonClick);
                if (onClick != undefined) {
                    onClick();
                }
            };
        }
        var timerBadge = this.getTimerBadge();
        var eventBadge = this.getEventBadge();
        var lockedClass = isLocked ? IdStyles.StateLocked : "";
        return (React.createElement(GridItemContainerDefault, { className: className, onClick: onClickWithSound },
            React.createElement("div", { className: "coop-project-grid-item" },
                React.createElement("div", { className: "flex flex--guts coop-project-background-img " + projectBackgroundClass + " " + lockedClass }),
                eventBadge,
                timerBadge)));
    };
    return GridItemCoopProjectDOM;
}(React.Component));
var mapState = function (state) { return ({
    activeProject: selectCoopProjectInfo(state),
    coopLevel: selectCoopInfo(state).level,
    runningCoopProjectEvent: selectRunningCoopProjectEventInfo(state),
}); };
export var GridItemCoopProject = connect(mapState)(GridItemCoopProjectDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/GridItemCoopProject.tsx
// module id = 2600
// module chunks = 3